// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35pXp","name":"Header_name__38mcO","birthday":"Header_birthday__2xzYg","skeleton":"Header_skeleton__22IMX"};